import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import { form } from '@angular/forms/signals';
import { JobsService } from '@ups/xplat/api/services';
import { MessageHelper } from '@ups/xplat/web/core';

@Component({
  selector: 'ups-bulk-message-modal',
  templateUrl: 'bulk-message-modal.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkMessageModalComponent {
  @Input() hrRefs: number[] = [];

  @Output() closed: EventEmitter<void> = new EventEmitter();

  // WI 31712: OnPush. WI 35846: a signal form; both fields are written only through [formField], whose model is
  // this signal, so OnPush re-renders on every edit.
  readonly model = signal({ message: '', excludeCautionEmployees: true });
  readonly messageForm = form(this.model);

  constructor(
    private jobsService: JobsService,
    private msgHelper: MessageHelper
  ) {}

  sendMessage() {
    this.jobsService
      .sendBulkMessage(
        this.hrRefs,
        this.model().message,
        this.model().excludeCautionEmployees
      )
      .subscribe(() => {
        this.msgHelper.success('Bulk message successfully sent.');
      });

    this.closeModal();
  }

  closeModal() {
    this.closed.emit();
  }
}
